import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-black-emphasis ps-0" }
const _hoisted_9 = {
  href: "#",
  class: "text-decoration-none text-black"
}
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-muted" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-muted" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-muted" }
const _hoisted_13 = { class: "badge text-outline-info" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_15 = { class: "dropdown" }
const _hoisted_16 = { class: "dropdown-menu" }
const _hoisted_17 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.checkPermission('AddNotification'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
              to: "/ajouter-notification"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1),
                _createTextVNode(" Envoyer une notification ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher une notification"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              }, " Message "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              }, " Destinataire "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              }, " Date d'envoi "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              }, " Statut ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("a", _hoisted_9, _toDisplayString((notification.message.length > 60) ? notification.message.substring(0, 60) + '...' : notification.message), 1)
                ]),
                _createElementVNode("td", _hoisted_10, _toDisplayString(notification?.abonne?.nomComplet), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.format_date(notification.createdAt)), 1),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(notification.estLu == false ? "Non lue" : "Lue"), 1)
                ]),
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", {
                      class: "badge text-white bg-primary fs-15 dropdown-toggle",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, [
                      _createTextVNode(" Actions "),
                      _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                    ], -1)),
                    _createElementVNode("ul", _hoisted_16, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          class: "dropdown-item d-flex align-items-center",
                          to: { name: 'ViewNotificationContentPage', params: { id: notification.id } }
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "flaticon-view position-relative ms-5 fs-12" }, null, -1),
                            _createTextVNode(" Détail ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}